import { render, staticRenderFns } from "./RowActions.vue?vue&type=template&id=fed8c67c&scoped=true&"
import script from "./RowActions.vue?vue&type=script&lang=ts&"
export * from "./RowActions.vue?vue&type=script&lang=ts&"
import style0 from "./RowActions.vue?vue&type=style&index=0&id=fed8c67c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed8c67c",
  null
  
)

export default component.exports